import { Injectable } from '@angular/core';

import { Oauth2Service } from '@common';
import { Observable, forkJoin as observableForkJoin } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { AcquisitionContextService } from '../../../context/child/acquisition-context.service';
import { CustomerContextService } from '../../../context/child/customer-context.service';
import { UserContextService } from '../../../context/child/user-context.service';
import { ContextService } from '../../../context/context.service';

/**
 * Created by fruysshaert on 23/03/2017.
 */
import { ContextInterfaceBase } from '../context.interface';
import { BrowseConfigClass } from './browse-config.class';

@Injectable({
    providedIn: 'root',
})
export class BrowseContextServiceBase implements ContextInterfaceBase {
    public static TYPES = {
        RENEW: 'RENOUVELLEMENT',
        VENTE_NUE: 'VENTE_NUE',
        ACQUISITION: 'ACQUISITION',
    };
    public typeParcours: string;

    public keySerialize: string = 'BrowseContextServiceBase';
    public browseConfig: BrowseConfigClass;

    constructor(
        protected acquisitionContextService: AcquisitionContextService,
        protected customerContextService: CustomerContextService,
        protected userContextService: UserContextService,
        protected oauth2Service: Oauth2Service,
    ) {}

    public create(config?: BrowseConfigClass): Observable<this> {
        const instance: BrowseContextServiceBase = new BrowseContextServiceBase(
            this.acquisitionContextService,
            this.customerContextService,
            this.userContextService,
            this.oauth2Service,
        );
        return instance.config(config) as Observable<this>;
    }

    public config(config: BrowseConfigClass): Observable<this> {
        return this.oauth2Service.autoLogin().pipe(map(() => this));
    }

    public updateContext(contextService: ContextService): Observable<ContextService> {
        const obsContext: Observable<ContextService>[] = [];
        if (
            this.oauth2Service.jwtPayload &&
            (this.oauth2Service.jwtPayload.user_type === 'CDV' || this.oauth2Service.jwtPayload.user_type === 'CDC')
        ) {
            obsContext.push(this.userContextService.create().pipe(mergeMap((res) => contextService.setContext(res))));
        } else if (this.oauth2Service.jwtPayload) {
            obsContext.push(
                this.customerContextService.create().pipe(
                    mergeMap((res) => contextService.setContext(res)),
                    mergeMap(() =>
                        this.acquisitionContextService.getPromoContextService
                            .create()
                            .pipe(mergeMap((res) => contextService.setContext(res))),
                    ),
                ),
            );
        } else {
            obsContext.push(
                this.acquisitionContextService.create().pipe(mergeMap((res) => contextService.setContext(res))),
            );
        }

        return observableForkJoin(obsContext).pipe(map(() => contextService));
    }

    public serialize(): { [index: string]: any } {
        return this.browseConfig;
    }
}
